import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-recargas',
  templateUrl: './recargas.component.html',
  styleUrls: ['./recargas.component.css']
})
export class RecargasComponent implements OnInit {

  constructor(
    private router: Router,
    public _auth: AuthService
  ) { }

  ngOnInit(): void {
    // Por defecto mostrar la lista de operadoras
    this.router.navigate(['/console/recargas/operadoras'], { replaceUrl: true });
  }

} 